import { FeedbotMiddleware, isThunk } from '../types'
import { amIBlockedByExclusiveUiSelector, doIHaveExclusiveUiOpenSelector } from './selectors'
import {
  reportClosingExclusiveUiToServer,
  reportOpeningExclusiveUiToServer
} from './socketServerConnectionService'
import { dismissedOpenedExclusiveUiToast, toastNotifyYouOpenedExclusiveUi } from './toasts'
import { closeAllExclusiveUi } from './actions'
import { areFeatureValuesReadySelector, featureValueSelector } from '../features/selectors'
import { SocketLog } from '../../lib/debugging/socketLog'

export const exclusiveUiMiddleware: FeedbotMiddleware = store => next => action => {
  if (isThunk(action)) {
    return next(action)
  }

  if (!areFeatureValuesReadySelector(store.getState())) {
    return next(action)
  }

  const doIHaveExclusiveUiOpen = doIHaveExclusiveUiOpenSelector(store.getState())
  const result = next(action)

  // Disabling feature only prevents user from getting blocked, but not from blocking others.
  // This seems to make much more sense, as it minimizes the surface for potential conflicts
  // While retaining the ability to circumvent the blocking mechanism if needed.
  if (
    featureValueSelector('CROSS_USER_UI_BLOCKING')(store.getState()) &&
    amIBlockedByExclusiveUiSelector(store.getState())
  ) {
    SocketLog.log('Notice', 'Closing exclusive UI because I am blocked by another user.')

    store.dispatch(closeAllExclusiveUi())
    return result
  }

  const nextDoIHaveExclusiveUiOpen = doIHaveExclusiveUiOpenSelector(store.getState())
  const didIJustOpenExclusiveUi = !doIHaveExclusiveUiOpen && nextDoIHaveExclusiveUiOpen
  const didIJustCloseExclusiveUi = doIHaveExclusiveUiOpen && !nextDoIHaveExclusiveUiOpen

  if (didIJustOpenExclusiveUi) {
    reportOpeningExclusiveUiToServer()
    toastNotifyYouOpenedExclusiveUi()
  }

  if (didIJustCloseExclusiveUi) {
    reportClosingExclusiveUiToServer()
    dismissedOpenedExclusiveUiToast()
  }

  return result
}
